import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { resolveAdminActiveTab } from '@/lib/adminNav';
import AdminNavTabs from '@/components/admin/AdminNavTabs';

/**
 * Shared admin chrome: panel title, primary tab nav, optional breadcrumbs/page title.
 */
export default function AdminPageShell({
  children,
  breadcrumbs = [],
  title,
  maxWidth = 'max-w-7xl',
  testId = 'admin-page-shell',
}) {
  const { t } = useLanguage();
  const location = useLocation();
  const activeTab = resolveAdminActiveTab(location.pathname, location.search);

  return (
    <div className="min-h-screen bg-[#F5F3EF]" data-testid={testId}>
      <div className={`${maxWidth} mx-auto px-3 sm:px-6 py-4 sm:py-8`}>
        <h1 className="font-heading text-2xl sm:text-3xl text-[#2B2B2B] tracking-tight mb-4 sm:mb-6">
          {t('admin.title')}
        </h1>
        <AdminNavTabs activeTab={activeTab} />
        {breadcrumbs.length > 0 && (
          <p className="text-[11px] text-[#5a5a5a] mb-2" data-testid="admin-breadcrumbs">
            {breadcrumbs.map((b, i) => (
              <span key={`${b.label}-${i}`}>
                {i > 0 && ' / '}
                {b.to ? (
                  <Link to={b.to} className="hover:text-[#0B3D2E]">
                    {b.label}
                  </Link>
                ) : (
                  b.label
                )}
              </span>
            ))}
          </p>
        )}
        {title && (
          <h2 className="font-heading text-xl sm:text-2xl text-[#2B2B2B] tracking-tight mb-4 sm:mb-6">
            {title}
          </h2>
        )}
        {children}
      </div>
    </div>
  );
}
